import IconLoading from '@/assets/icons/icon-loading.svg'
import { classNames } from '@/utils/helpers.ts'

import { InfoQuickViewData } from './types.ts'

interface InfoQuickViewContentProps {
  data: InfoQuickViewData
  isLoading: boolean
}

export const InfoQuickViewContent = ({
  data,
  isLoading,
}: InfoQuickViewContentProps) => {
  const displayedData = data.filter((d) => !!d.rows.length)
  const lastIndex = displayedData.length - 1

  if (isLoading) {
    return (
      <span className="flex items-center justify-center gap-2 gap-2 px-2">
        <IconLoading className="h-4 w-4 animate-spin" />
        <span>Loading...</span>
      </span>
    )
  }

  return (
    <div className="flex py-4">
      {displayedData.map(({ title, rows }, index) => (
        <div
          className={classNames('px-4', {
            'border-r-[1px] border-secondary-400':
              displayedData.length > 1 && index !== lastIndex,
          })}
          key={title}
        >
          <p className="mb-1 text-lg">{title}</p>
          <div className="flex flex-col justify-between gap-2">
            {rows.map((row) => (
              <div
                key={row.label}
                className="flex min-w-40 justify-between text-sm"
              >
                <span className="text-secondary-400">{row.label}</span>
                <span>{row.value}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
